<template>
  <div class="animated fadeIn">
    <div class="card success-message-card">
      <div class="card-header">
        <span>Điểm đến</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        
          <b-row>
            <b-col md="12">
             Cập nhật thành công!
            </b-col>
          </b-row>
       </div>
    </div>
  </div>
</template>

<style scoped>
.card.success-message-card {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  margin: 0;
  border-radius: 0;
}
</style>

<script>
export default {
  data() {
    return {
    
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    

    async fn_initDataDefault() {},

    fn_hashUrl() {

    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
    if (window.parent) {
      try{ 
        window.parent.document.querySelector("iframe").height = "400px";
      }
      catch(e){}
      window.parent.history.go(-2);
    }
  }
};
</script>
